import React from "react"
import styled, { css } from "styled-components"
import { Button as AntdButton } from "antd"
import Text from "./Text/Text"
import { Link } from "gatsby"
import _, { get } from "lodash"
import { colors } from "./Color"
import withQueryString from "../highOrderComponents/withQueryString"

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  > div {
    font-weight: 600 !important;

    ${props =>
      props.spread &&
      css`
        width: 100%;
        white-space: pre-wrap;
        text-align: center;
        padding: ${props => (props.size === "medium" ? "10px" : "5px")} 0;
      `}
  }
`

const Button = styled(AntdButton)`
  ${props =>
    props.spread && "width: 100% !important; height: auto !important;"};

  div > div {
    color: ${colors.tertiary} !important;
  }
  background: ${props => (props.dark ? colors.primary : "none")} !important;
  ${props =>
    props.dark
      ? css`
          border: none !important;
        `
      : css`
          border: 1px solid ${colors.tertiary} !important;
        `}

  &:hover {
    div > div {
      color: ${colors.teal} !important;
    }
    ${props =>
      props.dark
        ? css`
            background: ${colors.teal} !important;
            div > div {
              color: ${colors.tertiary} !important;
            }
          `
        : css`
            border: 1px solid ${colors.teal} !important;
          `}
  }
`

const SanityButton =
  ({
    text,
    internalLink,
    externalLink,
    dark = false,
    size = "medium",
    spread = false,
    queryString,
    state,
  }) => {
    const linkToInternalPage = get(internalLink, ["slug", "current"])

    const button = () => (
      <Button
        ghost={!dark}
        disabled={!internalLink && !externalLink}
        dark={dark}
        spread={spread}
        size="large"
      >
        <ButtonContent spread={spread} size={size}>
          <Text size={size}>{text}</Text>
        </ButtonContent>
      </Button>
    )

    let passedState = {}
    try {
      passedState = eval("() => (" + get(state, "code", "''") + ")")()
    } catch (err) {
      // console.log("Error on evaluating next state", state)
    }

    return internalLink ? (
      <Link
        to={linkToInternalPage}
        style={spread ? { width: "100%" } : null}
        state={{ ...passedState, meta: queryString }}
      >
        {button()}
      </Link>
    ) : (
      <a href={externalLink} style={spread ? { width: "100%" } : null}>
        {button()}
      </a>
    )
  }

export default withQueryString(SanityButton)
